import { useCallback } from 'react';
import { TextField } from '@mui/material';
import { sharedColors } from '../../utils/Style';
import { UserFilter } from '../../interfaces/User/UserFilter';

interface UserSearchBoxProps {
  label: string;
  filters: UserFilter;
  onChange: (newFilters: UserFilter) => void;
  fieldName: keyof UserFilter;
  onEnter: () => void;
}

export const UserSearchBox = (props: UserSearchBoxProps) => {
  const handleKeyDown = useCallback(
    (e: any) => {
      if (e.keyCode === 13) {
        props.onEnter();
      }
    },
    [props.onEnter],
  );

  return (
    <TextField
      size='small'
      label={props.label}
      value={props.filters[props.fieldName] ?? ''}
      onChange={(e) =>
        props.onChange({
          ...props.filters,
          [props.fieldName]: e.target.value,
        })
      }
      onKeyDown={handleKeyDown}
      sx={{
        minWidth: 250,
        maxWidth: 500,
        flexGrow: 1,
        backgroundColor: sharedColors.white,
        height: 'fit-content',
      }}
    />
  );
};
